import React, { useState } from 'react'
import { Card, Col, Row, Typography } from 'antd'
import { Clienttable, ModuleTopHeading, ProjectDetailtable } from '../../components';

const { Text } = Typography
const Clients = () => {

    const [ visible, setVisible] = useState(false)
    const [ edititem, setEditItem ] = useState(null)
    
   
    return (
        <>
            <Card className='shadow-d radius-12 mb-3'>
                <Row gutter={[24, 24]}>
                    <Col span={24}>
                        <ModuleTopHeading level={4} name='Clients'/>
                    </Col>
                    <Col span={24}>
                        <Clienttable 
                            {...{setEditItem,setVisible}}
                        />
                    </Col>
                </Row>
            </Card>
        </>
    )
}

export { Clients }
